<script>
import TableBlock from '@/components/Analysis/TableBlockMixin';

export default {
  mixins: [TableBlock],

  props: {
    yearly: {
      type: Boolean,
      default: true,
    },

    weighted: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    computedData() {
      const { sites, environmentalImpact, environmentalImpactWeighted, filteredCollaborators } = this.data;
      const computedSites = this.range ? sites.slice(this.range[0], this.range[1]) : sites;

      const entries = computedSites.map(site => {
        const evolution =
          environmentalImpact > 0 ? Math.round(((site.details.environmentalImpact - environmentalImpact) / environmentalImpact) * 100 * 100) / 100 : 0;
        const evolutionWeighted =
          environmentalImpactWeighted > 0
            ? Math.round(((site.details.environmentalImpactWeighted - environmentalImpactWeighted) / environmentalImpactWeighted) * 100 * 100) / 100
            : 0;

        return [
          this.buildSiteBlock(site, filteredCollaborators, this.forcedTransport),
          {
            value: this.yearly
              ? this.weighted
                ? (site.details.environmentalImpactWeighted * 436) / filteredCollaborators.length
                : (site.details.environmentalImpact * 436) / filteredCollaborators.length
              : site.details.environmentalImpact / filteredCollaborators.length,
            toFixedValue: 2,
            sub: ' kg',
          },
          {
            trend: this.weighted ? (evolutionWeighted === 0 ? 0 : evolutionWeighted < 0 ? 'down' : 'up') : evolution === 0 ? 0 : evolution < 0 ? 'down' : 'up',
            value: this.weighted ? Math.abs(evolutionWeighted) : Math.abs(evolution),
            sub: '%',
          },
        ];
      });

      return {
        data: {
          entries: [
            [
              {
                caption: this.$t('actualSites', this.data.actualSites.length),
                type: 'current-site',
                className: ['big', 'site', 'current-site'],
              },
              {
                value: this.yearly
                  ? this.weighted
                    ? (environmentalImpactWeighted * 436) / filteredCollaborators.length
                    : (environmentalImpact * 436) / filteredCollaborators.length
                  : environmentalImpact / filteredCollaborators.length,
                toFixedValue: 2,
                sub: ' kg',
              },
              {
                caption: '',
                className: 'current-site',
              },
            ],
            ...entries,
          ],
        },
      };
    },
  },
};
</script>
